import { render } from "./ClinicalData.vue?vue&type=template&id=06602ca2"
import script from "./ClinicalData.vue?vue&type=script&lang=js"
export * from "./ClinicalData.vue?vue&type=script&lang=js"

import "./ClinicalData.vue?vue&type=style&index=0&id=06602ca2&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__